import { Config } from '../config';
import { HttpService } from './http.service';

const path = `${Config.API}/api/v1/feature_flags`;

/**
 * Raw feature flags as returned by the API.
 * Values are strings ("true"/"false") that need normalization.
 */
export interface RawFeatureFlags extends Record<string, string | undefined> {
  ccr_enabled?: string;
  fleet_health_split_endpoints?: string;
}

/**
 * Normalized feature flags with proper boolean types.
 * Use this interface after normalization in useFeatureFlagsQuery hook.
 */
export interface FeatureFlags extends Record<string, boolean | undefined> {
  ccr_enabled?: boolean;
  fleet_health_split_endpoints?: boolean;
}

export abstract class FeatureFlagService {
  /**
   * Returns all feature flags from SSM Parameter Store.
   * Flags are stored under /feature-flags/ path in SSM.
   * @returns Map of feature flag names to their values
   */
  public static list = (): Promise<RawFeatureFlags> => {
    return HttpService.fetchAuthorized(path, {
      method: 'GET',
    });
  };
}
